/**
 * Open Modal javascript trigger
 */
function openModal(modal, opener){
  if(modal && typeof modal.show === 'function') {
    try {
      modal.show(opener);
    } catch (err) {
      console.error('Modal open error:', err);
    }
  }
}

/**
  * Dropdown component Events and Methods
  *
  * @param {element} element - Dropdown element
  */
 class Dropdown {
  static MQ_IPAD_PRO_LANDSCAPE = window.matchMedia('(min-width: 1024px) and (max-width: 1366px)');

  static collapse(dropdown) {
    if (!dropdown) return;

    Utility.CSS.remove(dropdown, 'open');

    const toggle = dropdown.querySelector('.dropdown-toggle');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');

    dropdown.querySelectorAll('.dropdown.open').forEach(child => {
      Utility.CSS.remove(child, 'open');
      const childToggle = child.querySelector('.dropdown-toggle');
      if (childToggle) childToggle.setAttribute('aria-expanded', 'false');
    });
  }

  constructor(element) {
    this.dropdown = element;
    this.toggleCTA = (Utility?.DomSelector?.$('.dropdown-toggle', element)) || element.querySelector('.dropdown-toggle');
    this.supportedEvents = ["click", "touchstart", "touchmove", "touchend", "mouseenter", "mouseleave", "focusout"];
    this.touchState = { startX: 0, startY: 0, moved: false };

    if (!this.toggleCTA) {
      console.warn('Dropdown toggle element not found:', element);
      return;
    }

    this.init();
  }

  init() {
    const handlers = {
      click: (evt) => {
        evt.preventDefault();
        this.toggleDropdown();
      },
      touchstart: (evt) => {
        const touch = evt.touches?.[0];
        if (!touch) return;
        this.touchState.startX = touch.clientX;
        this.touchState.startY = touch.clientY;
        this.touchState.moved = false;
      },
      touchmove: (evt) => {
        const touch = evt.touches?.[0];
        if (!touch || this.touchState.moved) return;

        const deltaX = Math.abs(touch.clientX - this.touchState.startX);
        const deltaY = Math.abs(touch.clientY - this.touchState.startY);
        if (deltaX > 10 || deltaY > 10) {
          this.touchState.moved = true;
        }
      },
      touchend: (evt) => {
        if (this.touchState.moved) {
          this.touchState.moved = false;
          return;
        }
        evt.preventDefault();
        this.toggleDropdown();
        this.touchState.moved = false;
      },
      mouseenter: () => {
        /* Dropdowns open on click only; hover disabled for all [is="drop-down"] */
      },
      mouseleave: () => {
        /* Dropdowns close on click/toggle or click-outside only */
      },
      focusout: (evt) => {
        if (!this.dropdown.contains(evt.relatedTarget) && this.dropdown.classList.contains('open')) {
          this.dropdownHide(this.dropdown);
        }
      }
    };

    this.supportedEvents.forEach((type) => {
      const target = (type === 'mouseleave' || type === 'focusout') ? this.dropdown : this.toggleCTA;
      const handler = handlers[type];
      if (handler) target.addEventListener(type, handler, { passive: type === 'touchmove' });
    });

    this.bindEvents();
  }

  bindEvents(){
    const closeBtn = Utility.DomSelector.$('.slideout-submenu', this.dropdown);
    if (closeBtn) {
      closeBtn.addEventListener('click', (evt) => {
        evt.preventDefault();
        this.dropdownToggle(this.dropdown);
      });
    }
  }

  /**
   * Toggle dropdown
   * @returns {Dropdown} Returns this for method chaining
   */
  toggleDropdown() {
    this.dropdownToggle(this.dropdown);
    return this; // Enable method chaining
  }

  /**
   * Toggle dropdown parent
   * @param {HTMLElement} dropdownParent 
   * @returns {Dropdown} Returns this for method chaining
   */
  dropdownToggle(dropdownParent) {
    setTimeout(() => {
      dropdownParent.classList.contains('open')
        ? this.dropdownHide(dropdownParent)
        : this.dropdownShow(dropdownParent);
    }, 50);
    return this; // Enable method chaining
  }

  /**
   * Show dropdown
   * @param {HTMLElement} dropdownParent 
   * @returns {Dropdown} Returns this for method chaining
   */
  dropdownShow(dropdownParent) {
    if (!dropdownParent) {
      return this;
    }

    if (Dropdown.MQ_IPAD_PRO_LANDSCAPE.matches && dropdownParent.parentElement) {
      dropdownParent.parentElement
        .querySelectorAll('[is="drop-down"].open')
        .forEach((openDropdown) => {
          if (openDropdown !== dropdownParent) Dropdown.collapse(openDropdown);
        });
    }

    this.toggleCTA.setAttribute('aria-expanded', true);
    Utility.CSS.add(dropdownParent, 'open');
    return this; // Enable method chaining
  }

  /**
   * Hide dropdown
   * @param {HTMLElement} dropdownParent 
   * @returns {Dropdown} Returns this for method chaining
   */
  dropdownHide(dropdownParent) {
    if (!dropdownParent) return this;

    Dropdown.collapse(dropdownParent);

    return this; // Enable method chaining
  }

  childOnFocusChange(dropdownParent) {
    const openDropdowns = Array.from(dropdownParent.parentElement.querySelectorAll('.dropdown.open'));
    const currentIndex = openDropdowns.indexOf(dropdownParent);
    openDropdowns.forEach((ele) => {
      const eleIndex = openDropdowns.indexOf(ele);
      if (eleIndex !== currentIndex) {
        Dropdown.collapse(ele);
      }
    });
    return this; // Enable method chaining
  }
}
const allDropdowns = Utility.DomSelector.$$('[is="drop-down"]');
allDropdowns.forEach((ele) => {
  new Dropdown(ele);
});

/**
* background Overlay
*/
class SiteOverlay extends HTMLElement{
  constructor() {
    super();
    this.overlayElement = Utility.DomSelector.byId('site-overlay');
    this.bindEvents();
  }

  /**
   * bind Click and Touchend event to this custom component
   */
  bindEvents(){
    this.addEventListener('click', this.onClick.bind(this));
    this.addEventListener('touchend', this.onClick.bind(this));
  }

  /**
   * Click event of Site overlay
   */
  onClick(){
    SiteOverlay.hideOverlay();
  }

  /**
   * Show Overlay
   * @param {string} drawerClass - Optional class to add based on drawer type
   * @returns {boolean} Returns true if overlay was shown, false if already visible
   */
   static showOverlay(drawerClass = null){
    const overlay = Utility.DomSelector.byId('site-overlay');
    if (overlay.classList.contains('overlay--body')) {
      return false; // Already visible
    }
    
    Utility.CSS.add(overlay, 'overlay--body');
    overlay.setAttribute('aria-hidden', 'true');
    Utility.CSS.add(document.body, 'scroll-fixed');
    
    // Add drawer-specific class if provided
    if (drawerClass) {
      Utility.CSS.add(overlay, drawerClass);
    }
    
    // Make background content inert (prevents focus and interaction)
    // const mainContent = Utility.DomSelector.$('main');
    // const header = Utility.DomSelector.$('header');
    // if (mainContent) mainContent.setAttribute('inert', '');
    // if (header) header.setAttribute('inert', '');
    
    return true; // Successfully shown
  }

  /**
   * Hide overlay
   * @returns {boolean} Returns true if overlay was hidden, false if already hidden
   */
  static hideOverlay(){
    const overlay = Utility.DomSelector.byId('site-overlay');
    if (!overlay.classList.contains('overlay--body')) {
      return false; // Already hidden
    }
    
    const openDrawers = Utility.DomSelector.$$('custom-drawer.open');
    openDrawers.forEach(drawer => {
      drawer.closeDrawer();
    });
    
    // Remove all drawer-specific overlay classes (keep only overlay--body and scroll-fixed)
    const overlayClasses = Array.from(overlay.classList).filter(cls => cls !== 'overlay--body' && cls !== 'scroll-fixed');
    overlayClasses.forEach(cls => Utility.CSS.remove(overlay, cls));
    
    Utility.CSS.remove(overlay, 'overlay--body');
    Utility.CSS.remove(document.body, 'scroll-fixed');
    
    // Remove inert from background content
    // const mainContent = Utility.DomSelector.$('main');
    // const header = Utility.DomSelector.$('header');
    // if (mainContent) mainContent.removeAttribute('inert');
    // if (header) header.removeAttribute('inert');
    
    return true; // Successfully hidden
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick.bind(this));
    this.removeEventListener('touchend', this.onClick.bind(this));
  }
}
customElements.define("site-overlay", SiteOverlay, {
  once: true
});

/**
* Custom Video
*/
class CustomVideo extends HTMLElement {
  constructor() {
    super();

    this.type = this.dataset.videoType;
    this.videoURL = this.dataset.videoId;
    this.placementType = this.dataset.placement;
    this.videoStatus = 'empty';
    
    this.container = this.closest('.custom-video-container');
    this.videoModal = document.getElementById('PopupModal-video');
    this.contentSection = Utility.DomSelector.$('.content-section', this);
    this.videoSection = Utility.DomSelector.$('.video-section', this);
    if(this.placementType == 'popup') this.videoSection = Utility.DomSelector.$('.video-container', this.videoModal);
    this.triggerVideo = Utility.DomSelector.$('[data-trigger-video]', this) || Utility.DomSelector.$('[data-trigger-video]', this.container);

    this.boundToggleView = this.toggleView.bind(this);
  }

  connectedCallback() {
    this.bindEvents();
  }

  disconnectedCallback() {
    if (this.triggerVideo && this.boundToggleView) {
      this.triggerVideo.removeEventListener('click', this.boundToggleView);
    }
  }

  /**
   * Binding events on the video button
   */
  bindEvents(){
    if(Utility.DomSelector.exists('[data-poster-video]', this)) this.managePosterVideos();
    if(this.triggerVideo) this.triggerVideo.addEventListener('click', this.boundToggleView);

    // Autoplay on init if placement is grid and autoplay is true and not in a swiper slide. Slider autoplay is managed by the manageSwiperSlides function to support slide init with deferred js loading.
    if(this.dataset.placement == 'grid' && this.dataset.autoplay == 'true' && !this.closest('swiper-slide')) this.autoplayOnInit();
    // if(this.placementType == 'grid') this.addEventListener('focusout', this.focusOut.bind(this));
  }

  /**
   * Focus Out Event to close drawer
   *
   * @param {event} Event instance
   */
  focusOut(_event){
    if(this.container.classList.contains('playing--video')) this.toggleView();
  }

  /**
   * Toggle of video modal
   * @returns {CustomVideo} Returns this for method chaining
   */
  toggleView(event){
    if(event) event.preventDefault();
    const isOpen = this.container.classList.contains('playing--video');
    if (isOpen) {
      this.hideContent();
    } else {
      this.showContent();
    }
    return this; // Enable method chaining
  }

  /**
   * Show panel content
   * @returns {CustomVideo} Returns this for method chaining
   */
  showContent() {
    if (this.videoStatus === 'empty' || this.placementType === 'popup') {
      const videoElement = this._buildVideo();
      if (!videoElement) {
        console.error('Failed to build video element');
        return this;
      }
      
      videoElement.id = 'custom-video' + Math.floor((Math.random() * 100) + 1);
      
      if (!this.videoSection) {
        console.error('Video section not found');
        return this;
      }
      
      this.videoSection.appendChild(videoElement);
      this.videoStatus = 'loaded';

      setTimeout(() => {
        (this.placementType === 'popup') ? openModal(this.videoModal, this.triggerVideo) : Utility.CSS.add(this.container, 'playing--video');
        this.videoSection.removeAttribute('inert');
        this.videoSection.setAttribute('aria-hidden', 'false');
        if(this.dataset.controls === 'true') this.pauseOnVisibilityChange(videoElement);
      }, 500);
    } else {
      const videoElement = Utility.DomSelector.$('.video-section video', this) || Utility.DomSelector.$('.video-section iframe', this);
      if (videoElement) {
        Utility.CSS.add(this.container, 'playing--video');
        this._playVideo(videoElement);
      }
    }
    return this; // Enable method chaining
  }

  /**
   * Hide panel content
   * @returns {CustomVideo} Returns this for method chaining
   */
  hideContent() {
    Utility.CSS.remove(this.container, 'playing--video');
    this.videoSection.setAttribute('inert', '');
    this.videoSection.setAttribute('aria-hidden', 'true');
    const videoElement = Utility.DomSelector.$('.video-section video', this) || Utility.DomSelector.$('.video-section iframe', this);
    if (videoElement) {
      this._pauseVideo(videoElement);
    }
    return this; // Enable method chaining
  }

  _playVideo(video){
    if (!video) return;

    try {
      if(this.type === 'local'){
        video.play().catch(err => console.warn('Video autoplay blocked:', err));
      } else if(this.type === 'youtube'){
        video.contentWindow?.postMessage('{"event":"command","func":"playVideo","args":""}', 'https://www.youtube.com');
      }
    } catch (err) {
      console.error('Play video error:', err);
    }
  }

  _pauseVideo(video) {
    if (!video) return;
    
    try {
      if (this.type === 'local') {
        video.pause();
      } else if (this.type === 'youtube') {
        video.contentWindow?.postMessage('{"event":"command","func":"pauseVideo","args":""}', 'https://www.youtube.com');
      }
    } catch (err) {
      console.error('Pause video error:', err);
    }
  }

  /**
   * Create the video html element
   */
  _buildVideo(){
    try {
      if (!this.videoURL) {
        console.error('Video URL is missing');
        return null;
      }

      const hasControls = this.dataset.controls === 'true';
      const isMuted = this.dataset.muted === 'true';
      const isLoop = this.dataset.loop === 'true';

      if(this.type === 'local'){
        const video = document.createElement('video');
        video.src = this.videoURL;
        video.autoplay = true;
        video.playsInline = true;
        if(hasControls) video.controls = true;
        if(isMuted) video.muted = true;
        if(isLoop) video.loop = true;
        return video;
      }

      if(this.type === 'youtube'){
        const videoID = this.videoURL.replace('https://www.youtube.com/watch?v=', '');
        if (!videoID) {
          console.error('Invalid YouTube URL');
          return null;
        }
        const video = document.createElement("iframe");
        video.setAttribute("allowfullscreen", "");
        video.setAttribute("frameborder", "0");
        video.setAttribute("allow", "autoplay");
        video.setAttribute("src", `https://www.youtube.com/embed/${videoID}?rel=0&showinfo=0&autoplay=1&mute=${isMuted ? 1 : 0}&controls=${hasControls ? 1 : 0}&loop=${isLoop ? 1 : 0}&enablejsapi=1&origin=${window.origin}`);
        return video;
      }

      return null;
    } catch (err) {
      console.error('Video build error:', err);
      return null;
    }
  }

  /**
   * Pause video on scroll when out of viewport
   */
  pauseOnVisibilityChange(videoEle){
    if (!videoEle) return;
    
    this.scrollObserver = Utility.Observer.onChange(
      videoEle,
      null,  // onEnter - no action needed
      (video) => {  // onExit - pause video
        if(!video || video.contentWindow == null){
          this.scrollObserver?.disconnect();
          return;
        }
        this._pauseVideo(video);
      }
    );
  }

  /**
   * Poster Video Autoplay
   */
  managePosterVideos(){
    const posterVideo = Utility.DomSelector.$('[data-poster-video]', this);
    if(!posterVideo) return;

    Utility.Observer.once(posterVideo, (video) => {
      try {
        if (!video.dataset.src) return;
        const sourceTag = document.createElement('source');
        sourceTag.src = video.dataset.src;
        sourceTag.type = "video/mp4";
        video.appendChild(sourceTag);
        video.play().catch(err => console.warn('Poster video autoplay blocked:', err));
      } catch (err) {
        console.error('Poster video error:', err);
      }
    });
  }

  autoplayOnInit(element = this){
    Utility.Observer.once(element, (el, entry) => {
      if(entry.intersectionRatio > 0){
        el.toggleView();
      }
    });
  }
}
customElements.define("custom-video", CustomVideo);

/**
* Modal Dialogue
*
*/
class ModalDialog extends HTMLElement {
  constructor() {
    super();

    this.isOpen = false;
    this.modal = Utility.DomSelector.$('.modal', this);
    this.modalOpeners = Utility.DomSelector.$$(`[data-modal-opener="${this.id}"]`);
    this.closeBtn = Utility.DomSelector.$('[id^="ModalClose-"]', this);

    this.setAttribute('aria-hidden', 'true');
    this.setAttribute('inert', '');
  }

  connectedCallback() {
    this.modalOpeners.forEach((opener)=>{
      opener.addEventListener('click', (evt)=>{
        evt.preventDefault();
        this.show(opener);
      });
    });

    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', this.hide.bind(this));
    }

    this.addEventListener('click', (evt) => {
      if (evt.target === this && !this.hasAttribute('data-no-backdrop-close')) this.hide();
    });

    this.addEventListener('keyup', (evt) => {
      if (evt.code && evt.code.toUpperCase() === 'ESCAPE' && !this.hasAttribute('data-no-backdrop-close')) this.hide();
    });
  }

  // Clean up event listeners
  disconnectedCallback() {
    this.isOpen = false;

    this.modalOpeners.forEach((opener) => {
      opener.removeEventListener('click', this.show.bind(this));
    });

    if (this.closeBtn) {
      this.closeBtn.removeEventListener('click', this.hide.bind(this));
    }

    this.removeEventListener('click', this.hide);
    this.removeEventListener('keyup', this.hide);
  }

  /**
   * Open the Modal
   * @param {element} opener 
   * @returns {ModalDialog} Returns this for method chaining
   */
  show(opener) {
    if (this.isOpen) return this; // Prevent opening if already open

    this.isOpen = true;
    this.openedBy = opener;
    Utility.CSS.add(this.modal, 'open');
    this.removeAttribute('inert');
    this.setAttribute('aria-hidden', 'false');

    SiteOverlay.showOverlay();
    
    // Announce modal opening with specific name
    const modalName = this.getAttribute('aria-label') || 'Modal Dialogue';
    Utility.announceToScreenReader(`${modalName} modal opened`);
    
    Utility.Focus.trap(this, this.closeBtn);
    
    return this; // Enable method chaining
  }

  /**
   * Close Modal Dialogue
   * @returns {ModalDialog} Returns this for method chaining
   */
  hide() {
    if (!this.isOpen) return this; // Prevent closing if already closed

    this.isOpen = false;
    Utility.CSS.remove(this.modal, 'open');
    this.setAttribute('inert', '');
    this.setAttribute('aria-hidden', 'true');

    SiteOverlay.hideOverlay();
    
    // Announce modal closing with specific name
    const modalName = this.getAttribute('aria-label') || 'Modal Dialogue';
    Utility.announceToScreenReader(`${modalName} modal closed`);
    
    Utility.Focus.release(this.openedBy);
    if(this.id == 'PopupModal-video') {
      Utility.DomSelector.$('.video-container', this).innerHTML = '';
    }
    
    return this; // Enable method chaining
  }
}
customElements.define('modal-dialog', ModalDialog);

class CustomDrawer extends HTMLElement {
  constructor() {
      super();
      this.isOpen = false;

      this.openedBy = null;
      this.toggleDrawer = Utility.DomSelector.$$(`[data-toggleDrawer="${this.id}"], a[href="#${this.id}"]`);
      this.closeButtons = Utility.DomSelector.$$('[data-closedrawer]', this);
      this.forceFocus = Utility.DomSelector.$('.first-focusable-ele', this) || Utility.DomSelector.$('.drawer-header', this);
      this.setAttribute('aria-hidden', 'true');
      this.setAttribute('inert', '');
  }

  connectedCallback() {
    this.bindEvents()
  }

  disconnectedCallback() {
    this.toggleDrawer.forEach(btn => btn.removeEventListener('click', this.openDrawer()));

    this.closeButtons.forEach(btn => btn.removeEventListener('click', this.closeDrawer.bind(this)));
    this.removeEventListener('keyup', this.onKeyUp.bind(this));
    this.removeEventListener('focusout', this.focusOut.bind(this));
  }

  bindEvents(){
    this.toggleDrawer.forEach(btn => {
      btn.setAttribute('aria-expanded', false);
      btn.addEventListener('click', (evt) => {
        evt.preventDefault();
        (this.isOpen) ? this.closeDrawer(evt) : this.openDrawer(evt.currentTarget);
      });
    });

    this.closeButtons.forEach(btn => btn.addEventListener('click', this.closeDrawer.bind(this)));
    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.focusOut.bind(this));
  }

  /**
   * Escape Key Press to close drawer when focus is within the container
   */
  onKeyUp(event) {
    const key = typeof event.key === 'string' ? event.key.toUpperCase() : '';
    const code = typeof event.code === 'string' ? event.code.toUpperCase() : '';
    const isEscapeKey = key === 'ESCAPE' || code === 'ESCAPE' || event.keyCode === 27;
    if (!isEscapeKey) return;
    this.closeDrawer();
  }

  /**
   * Focus Out Event to close drawer
   */
  focusOut(evt){
    if (!this.contains(evt.relatedTarget) && this.open) {
      this.closeDrawer();
    }
  }

  openDrawer(opener) {
    // Prevent opening if already open
    if (this.isOpen) return this;

    this.resetOtherDrawers();

    this.isOpen = true;
    this.openedBy = opener || null;
    Utility.CSS.add(this, 'open');
    this.removeAttribute('inert');
    this.setAttribute('aria-hidden', 'false');

    // Create drawer-specific overlay class from drawer ID
    const drawerClass = this.id || null;
    SiteOverlay.showOverlay(drawerClass);
    
    // Add below-header class to overlay if drawer has it
    const overlay = Utility.DomSelector.byId('site-overlay');
    if (overlay && this.classList.contains('below-header')) {
      Utility.CSS.add(overlay, 'below-header');
    }
    
    this.openedBy?.setAttribute('aria-expanded', true);
    Utility.Focus.trap(this, this.forceFocus);
    
    // Announce drawer opening to screen readers
    const drawerName = this.getAttribute('aria-label') || 'Drawer';
    Utility.announceToScreenReader(`${drawerName} drawer opened`);
    
    return this; // Enable method chaining
  }

  closeDrawer() {
      if (!this.isOpen) return this;

      Utility.CSS.remove(this, 'open');
      
      // Remove drawer-specific overlay class and below-header class
      const overlay = Utility.DomSelector.byId('site-overlay');
      if (overlay && this.id) {
        Utility.CSS.remove(overlay, this.id);
        Utility.CSS.remove(overlay, 'below-header');
      }
      
      SiteOverlay.hideOverlay();

      this.isOpen = false;
      this.setAttribute('inert', '');
      this.setAttribute('aria-hidden', 'true');
      this.hideOpenPanels();
      this.openedBy?.setAttribute('aria-expanded', false);
      Utility.Focus.release(this.openedBy);
      
      // Announce drawer closing to screen readers
      const drawerName = this.getAttribute('aria-label') || 'Drawer';
      Utility.announceToScreenReader(`${drawerName} drawer closed`);
      
      if(this.id == 'quickshop-drawer') {
        Utility.DomSelector.$('[data-quickshop-body]', this).innerHTML = '';
        const backBtn = this.querySelector('[data-quickshop-back-to-cart]');
        if (backBtn) {
          backBtn.classList.add('d-none');
          backBtn.onclick = null;
        }
      }else if(this.id == 'header-search-layer') {
        const searchInput = this.querySelector('input[name="q"]');
        if(searchInput) {
          searchInput.value = '';
          searchInput.dispatchEvent(new Event('input'));
        }
      }
      this.openedBy = null;
      
      return this; // Enable method chaining
  }

  resetOtherDrawers(){
    const openDrawers = Utility.DomSelector.$$('custom-drawer.open');
    openDrawers.forEach(drawer => {
      drawer.closeDrawer();
    });
    return this; // Enable method chaining
  }

  hideOpenPanels(){
    let openPanels = this.querySelectorAll('[is="collapsiblePanel"].open');
    openPanels.forEach(panel => panel.querySelector('[data-toggle="panel"]').click());

    let openDropdowns = Array.from(this.querySelectorAll('[is="drop-down"].open'));
    openDropdowns.forEach((ele) => {
      Utility.CSS.remove(ele, 'open');
      Utility.DomSelector.$('[data-toggle="open"]', ele)?.setAttribute('aria-expanded', false);
    });
    return this; // Enable method chaining
  }
}
customElements.define('custom-drawer', CustomDrawer);

/**
   * Manage Custom Notification Trigger
   *
   */
class ToastNotification extends HTMLElement {
  constructor() {
    super();

    this.container = Utility.DomSelector.$('.snotifyToast', this);
    this.closeBtn = Utility.DomSelector.$('.snotifyToast__close', this);
    this.animateNotifcation = null;

    // Set ARIA role for accessibility
    this.container.setAttribute('role', 'alert');
    this.setAttribute('aria-hidden', 'true');
    this.setAttribute('inert', '');
  }

  connectedCallback() {
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.hide();
      });
    }
  }

  disconnectedCallback() {
    if (this.closeBtn) {
      this.closeBtn.removeEventListener('click', this.hide.bind(this));
    }
  }

  /**
   * Notification Type
   * @param {string} title 
   * @param {string} body 
   * @param {object} options 
   * @returns {ToastNotification} Returns this for method chaining
   */
  updateNotification(title, body, options){
    this.setAttribute('aria-hidden', 'false');
    this.removeAttribute('inert');

    Utility.CSS.add(this.container, 'open', `snotify-${options.type}`);
    Utility.DomSelector.$('.snotifyToast__title', this).textContent = title;
    Utility.DomSelector.$('.snotifyToast__body', this).textContent = body;

    this._manageToggle(options.timeout);
    
    return this; // Enable method chaining
  }

  /**
   * Duration of notification to hide again
   * @param timeout 
   */
  _manageToggle(timeout) {
    this.progressBar = Utility.DomSelector.$('[data-toast-pr]', this);
    const totalFrames = Math.ceil(timeout / 16.67) / 2;
    let frame =0; 
    let width = 0;

    this.animateNotifcation = () => {
      width = (frame / totalFrames) * 100;
      this.progressBar.setAttribute('style', `width: ${width}%`);
      if (frame < totalFrames) {
        frame++;
        requestAnimationFrame(this.animateNotifcation);
      } else {
        this.closeBtn.dispatchEvent(new Event('click'));
      }
    };
    requestAnimationFrame(this.animateNotifcation);
  }

  /**
   * Hide notification
   * @returns {ToastNotification} Returns this for method chaining
   */
  hide() {
    if (this.animateNotification) {
      cancelAnimationFrame(this.animateNotification);
    }
    this.setAttribute('aria-hidden', 'true');
    this.setAttribute('inert', '');

    this.container.className = 'snotifyToast';
    [Utility.DomSelector.$('.snotifyToast__title', this),Utility.DomSelector.$('.snotifyToast__body', this)].forEach(ele => ele.textContent = '');
    Utility.DomSelector.$("[data-toast-pr]", this).removeAttribute("style");

    return this; // Enable method chaining
  }
}
customElements.define("toast-notification", ToastNotification);
window.notificationEle = Utility.DomSelector.$('toast-notification');

//===============================================================================================================
//          Video Management Functions for Custom Video in Swiper Slides                                        //
//===============================================================================================================

/**
 * Handle slide video play/pause on slide change
 * @param {HTMLElement} slide 
 * @param {boolean} shouldPlay 
 */
const handleSlideVideo = (slide, shouldPlay) => {
  if (!slide) return;

  const videoHost = Utility.DomSelector.$('custom-video', slide);
  if (!videoHost) return;

  const media = Utility.DomSelector.$('video', videoHost) || Utility.DomSelector.$('iframe', videoHost);
  if (videoHost.videoStatus == 'loaded' && !media) return;

  try {
    if (shouldPlay) {
      if (videoHost.videoStatus === 'empty') {
        videoHost.toggleView();
      } else {
        videoHost._playVideo(media);
      }
    } else if (videoHost.dataset.controls === 'true') {
      videoHost._pauseVideo(media);
    }
  } catch (err) {
    console.error('Swiper slide video control error:', err);
  }
};

/**
 * Run autoplay on first active slide if autoplay is true and placement is grid
 * @param {HTMLElement} swiperEl 
 */
const runAutoplayIfActive = (swiperEl) => {
  if(!swiperEl || !swiperEl.querySelector('custom-video')) return;

  const firstActiveSlide = Utility.DomSelector.$('swiper-slide', swiperEl);
  if(!firstActiveSlide) return;

  const customVideo = firstActiveSlide.querySelector('custom-video');
  if(!customVideo) return;

  if(customVideo.dataset.autoplay === 'true' && customVideo.dataset.placement === 'grid') customVideo.autoplayOnInit(customVideo);
};

/**
 * Manage Swiper slide video control
 * @param {HTMLElement} swiperEl 
 */
const manageSwiperSlides = () => {
  const swiperSliders = Utility.DomSelector.$$('swiper-container');
  if(!swiperSliders.length) return;

  swiperSliders.forEach(swiperEl => {
    swiperEl.addEventListener('swiper:init', () => runAutoplayIfActive(swiperEl), { once: true });
    swiperEl.addEventListener('swiperslidechange', ({ detail }) => {
      const swiperInstance = detail && detail[0];
      if (!swiperInstance) return;

      const { activeIndex, previousIndex, slides } = swiperInstance;
      if (!slides || activeIndex == null || previousIndex == null) return;

      const prevSlide = slides[previousIndex];
      const activeSlide = slides[activeIndex];

      handleSlideVideo(prevSlide, false);
      handleSlideVideo(activeSlide, true);
    });
  });
};
manageSwiperSlides();

// Wait for Swiper JS to load
customElements.whenDefined('swiper-container')
  .then(() => {
    console.log('Swiper JS is loaded!');
})
  .catch((error) => {
    console.error('Swiper failed to load:', error);
});

//===============================================================================================================
//          End of Video Management Functions for Custom Video and Swiper Slide Components                      //
//===============================================================================================================


//===============================================================================================================
//          Update Product Media Height Functions for Product Cards                                        //
//===============================================================================================================

(() => {
  const NAV_SELECTOR = '.custom-swiper-navigation';
  const TAB_TOGGLE_SELECTOR = '[data-toggle="tab"]';
  const TAB_PANEL_SELECTOR = '[data-tabpanel]';
  const TAB_CONTENT_CLASS = 'tabcontent';
  const DELAY = 50;
  const RESIZE_DELAY = 100;

  const updateHeights = () => {
    const cards = document.querySelectorAll('.card-product');
    if (cards.length === 0) return;

    // Batch read phase: collect all data
    // Reading offsetHeight forces layout, so we batch all reads together
    const updates = [];
    for (let i = 0; i < cards.length; i++) {
      const card = cards[i];
      if (!card || card.offsetParent === null) continue;

      const media = card.querySelector('.product--media') || card.querySelector('.card-img');
      if (!media) continue;

      // Query nav in read phase (doesn't force layout, but batches DOM queries)
      const nav = card.closest('.swiper-wrapper__custom, section, .slider-wrapper')?.querySelector(NAV_SELECTOR);

      // Store all data for batch write phase
      updates.push({
        card,
        height: media.offsetHeight, // This forces layout - batched with all other reads
        nav
      });
    }

    // Batch write phase: apply all style changes at once
    // This reduces layout thrashing by grouping all writes together
    for (let i = 0; i < updates.length; i++) {
      const { card, height, nav } = updates[i];
      const heightStr = `${height}px`;

      // Apply card style
      card.style.setProperty('--product-media-height', heightStr);

      // Apply nav styles if nav exists
      if (nav) {
        nav.style.setProperty('--product-media-height', heightStr);
        nav.style.setProperty('--nav-opacity', '1');
        nav.classList.add('arrow-center-image');
      }
    }
  };

  const scheduleUpdate = (delay = 0) => window.setTimeout(updateHeights, delay);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateHeights, { once: true });
  } else {
    updateHeights();
  }

  window.addEventListener('load', updateHeights);

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(updateHeights, RESIZE_DELAY);
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest(TAB_TOGGLE_SELECTOR)) scheduleUpdate(DELAY);
  });

  const observer = new MutationObserver((mutations) => {
    const shouldUpdate = mutations.some(({ target, attributeName }) => (
      ['aria-hidden', 'class'].includes(attributeName) &&
      target.classList?.contains(TAB_CONTENT_CLASS) &&
      target.classList.contains('open') &&
      target.getAttribute('aria-hidden') === 'false'
    ));

    if (shouldUpdate) scheduleUpdate(DELAY);
  });

  document.querySelectorAll(TAB_PANEL_SELECTOR).forEach((panel) => {
    observer.observe(panel, { attributes: true, attributeFilter: ['aria-hidden', 'class'] });
  });

  document.addEventListener('product-media-height-update', () => scheduleUpdate(DELAY));
})();

//===============================================================================================================
//          End of Update Product Media Height Functions for Product Cards                                        //
//===============================================================================================================

//===============================================================================================================
//          Global Handler for Dropdowns and Custom Selects - Close all open on outside click                 //
//===============================================================================================================

(() => {
  /**
   * Closes all open custom-select dropdowns
   */
  const closeAllOpenSelects = () => {
    document.querySelectorAll('custom-select.open').forEach(select => {
      if (select.closeDropdown && typeof select.closeDropdown === 'function') {
        select.closeDropdown();
      }
    });
  };

  /**
   * Closes all open dropdown elements
   */
  const closeAllOpenDropdowns = () => {
    document.querySelectorAll('[is="drop-down"].open').forEach(dropdown => {
      Dropdown.collapse(dropdown);
    });
  };

  /**
   * Closes all open dropdown/select components
   */
  const closeAllOpenComponents = () => {
    closeAllOpenSelects();
    closeAllOpenDropdowns();
  };

  /**
   * Handles clicks/touches outside dropdown and custom-select elements
   * @param {Event} event - Click or touch event
   */
  const handleOutsideInteraction = (event) => {
    // Don't close if interaction is inside any dropdown or custom-select element
    if (event.target.closest('custom-select') || event.target.closest('[is="drop-down"]')) return;
    closeAllOpenComponents();
  };

  // Add global listeners for both click and touchstart (mobile support)
  document.body.addEventListener('click', handleOutsideInteraction);
  document.body.addEventListener('touchstart', handleOutsideInteraction, { passive: true });
})();

//===============================================================================================================
//          End of Global Handler for Dropdowns and Custom Selects                                               //

//===============================================================================================================
//          Header and Announcement Bar Height Calculator                                                       //
//===============================================================================================================


function setHeaderTopbarCSSVars() {
  const root = document.documentElement;
  const header = document.querySelector('.section-header');
  const topbar = document.querySelector('.topbar');
  
  if (header) {
    const headerHeight = header.getBoundingClientRect().height;
    root.style.setProperty('--header-height', headerHeight + 'px');
  }
  if (topbar) {
    const topbarHeight = topbar.getBoundingClientRect().height;
    root.style.setProperty('--announcement-bar-height', topbarHeight + 'px');
  }
}
setHeaderTopbarCSSVars();

let headerTopbarResizeTimer;
window.addEventListener('resize', () => {
  setHeaderTopbarCSSVars();
  clearTimeout(headerTopbarResizeTimer);
  headerTopbarResizeTimer = setTimeout(setHeaderTopbarCSSVars, 120);
});
window.addEventListener('orientationchange', () => {
  setTimeout(setHeaderTopbarCSSVars, 120);
});

//===============================================================================================================
// B2B Account section height (for animations / layout). Uses actual rendered height including padding.
//===============================================================================================================

function setB2BAccountSectionHeight() {
  const el = document.querySelector('.b2b-account-section');
  if (el) document.documentElement.style.setProperty('--b2b-account-section-height', el.offsetHeight + 'px');
}
setB2BAccountSectionHeight();
window.addEventListener('resize', setB2BAccountSectionHeight);
window.addEventListener('load', setB2BAccountSectionHeight);

//===============================================================================================================
//          End of Header and Announcement Bar Height Calculator                                               //
//===============================================================================================================

//===============================================================================================================
//          Swym Wishlist Integration for Custom Buttons                                                        //
//===============================================================================================================

(function() {
  function initSwymWishlistButtons() {
    const wishlistButtons = document.querySelectorAll('.swym-add-to-wishlist:not([data-swym-click-bound])');
    
    if (!wishlistButtons.length) return;
    
    function waitForSwym(callback, maxAttempts = 50) {
      let attempts = 0;
      const checkSwym = setInterval(() => {
        attempts++;
        if (typeof window._swat !== 'undefined' && window._swat.addToWishList) {
          clearInterval(checkSwym);
          callback();
        } else if (attempts >= maxAttempts) {
          clearInterval(checkSwym);
          console.warn('Swym API not available');
        }
      }, 100);
    }
    
    function updateButtonState(button, isInWishlist) {
      const emptyIcon = button.querySelector('.wishlist-icon-empty');
      const filledIcon = button.querySelector('.wishlist-icon-filled');
      
      if (isInWishlist) {
        button.classList.add('active');
        if (emptyIcon) emptyIcon.classList.add('d-none');
        if (filledIcon) filledIcon.classList.remove('d-none');
      } else {
        button.classList.remove('active');
        if (emptyIcon) emptyIcon.classList.remove('d-none');
        if (filledIcon) filledIcon.classList.add('d-none');
      }
    }
    
    function checkWishlistStatus() {
      if (typeof window._swat === 'undefined') return;
      
      const allWishlistButtons = document.querySelectorAll('.swym-add-to-wishlist');
      allWishlistButtons.forEach(button => {
        const productId = button.dataset.productId;
        const variantId = button.dataset.variantId;
        
        if (productId && variantId) {
          window._swat.fetch(function(products) {
            const isInWishlist = products.some(item => 
              String(item.epi) === String(variantId) || String(item.empi) === String(productId)
            );
            updateButtonState(button, isInWishlist);
          });
        }
      });
    }
    
    function handleWishlistClick(e) {
      e.preventDefault();
      e.stopPropagation();
      
      const button = e.currentTarget;
      const productId = parseInt(button.dataset.productId);
      const variantId = parseInt(button.dataset.variantId);
      const productUrl = button.dataset.productUrl;
      
      if (!productId || !variantId || typeof window._swat === 'undefined') {
        console.warn('Missing product data or Swym not loaded');
        return;
      }
      
      button.style.pointerEvents = 'none';
      
      const isInWishlist = button.classList.contains('active');
      
      if (isInWishlist) {
        window._swat.fetch(function(products) {
          const product = products.find(item => 
            String(item.epi) === String(variantId) || String(item.empi) === String(productId)
          );
          if (product) {
            window._swat.removeFromWishList(product, function() {
              updateButtonState(button, false);
              button.style.pointerEvents = '';
            }, function(error) {
              console.error('Error removing from wishlist:', error);
              button.style.pointerEvents = '';
            });
          } else {
            button.style.pointerEvents = '';
          }
        });
      } else {
        const productData = {
          epi: variantId,
          empi: productId,
          du: productUrl
        };
        
        window._swat.addToWishList(productData, function() {
          updateButtonState(button, true);
          button.style.pointerEvents = '';
        }, function(error) {
          console.error('Error adding to wishlist:', error);
          button.style.pointerEvents = '';
        });
      }
    }
    
    wishlistButtons.forEach(button => {
      button.setAttribute('data-swym-click-bound', 'true');
      button.addEventListener('click', handleWishlistClick);
    });
    
    waitForSwym(checkWishlistStatus);
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSwymWishlistButtons);
  } else {
    initSwymWishlistButtons();
  }
  
  window.initSwymWishlistButtons = initSwymWishlistButtons;
  
  const observer = new MutationObserver((mutations) => {
    let hasNewButtons = false;
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) {
          const newButtons = node.querySelectorAll ? node.querySelectorAll('.swym-add-to-wishlist:not([data-swym-initialized])') : [];
          if (newButtons.length > 0) {
            hasNewButtons = true;
            newButtons.forEach(button => {
              button.setAttribute('data-swym-initialized', 'true');
            });
          }
        }
      });
    });
    if (hasNewButtons) {
      initSwymWishlistButtons();
    }
  });
  
  observer.observe(document.body, { childList: true, subtree: true });
})();

//===============================================================================================================
//          End of Swym Wishlist Integration                                                                    //
//===============================================================================================================